import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRBAC } from '../contexts/RBACContext';
import LoadingState from '../components/common/LoadingState';
import ProductsView from '../components/dashboard/purchase/ProductsView';

/**
 * ProductManagement Page - Sprint5-Story-05
 * /shop/admin/products: the same Product Management view as Products in the
 * Purchase panel, on its own page.
 * SECURITY: Requires 'Shop Management' 'Manage' permission
 */

export default function ProductManagement() {
  const navigate = useNavigate();
  const { hasPermission, isLoading: rbacLoading, permissions } = useRBAC();

  const permissionsLoaded = Object.keys(permissions || {}).length > 0;
  const canManageShop = !rbacLoading && permissionsLoaded && hasPermission('Shop Management', 'Manage');

  // SECURITY CHECK: Redirect unauthorized users (once permissions have loaded)
  useEffect(() => {
    if (rbacLoading || !permissionsLoaded) return;

    if (!canManageShop) {
      console.warn('Unauthorized access attempt to Product Management');
      navigate('/access-denied');
    }
  }, [canManageShop, navigate, permissionsLoaded, rbacLoading]);

  if (rbacLoading) {
    return <LoadingState message="Loading permissions..." fullScreen />;
  }

  if (!canManageShop) {
    return null;
  }

  return (
    <div className="vv-page">
      <ProductsView />
    </div>
  );
}
